import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals } from "ramda";
import { SelectLink } from "@interdependence-ui";
import { sort } from "utils/sort";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
export default /*#__PURE__*/memo(function SelectRelatedMeasure(props) {
  var selected = props.selected,
    measures = props.measures;
  var sortedOptions = sort(function (x) {
    return x.label;
  }, measures);
  return /*#__PURE__*/_jsx(SelectLink, _objectSpread({
    id: "select-relatedmeasure",
    label: "V\xE4lj en relaterad indikator",
    hideLabel: true,
    _selected: sortedOptions.findIndex(function (option) {
      return equals(option.id, selected);
    }),
    options: sortedOptions
  }, extendedSystemStylesProps(styledSystemKeys, props)), sortedOptions);
}, function (prev, curr) {
  return equals(curr.selected, prev.selected) && equals(curr.measures, prev.measures);
});